import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ActivityIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.757 13.656a1 1 0 0 1-1.414 0 8 8 0 0 1 0-11.312 1 1 0 1 1 1.414 1.414 6 6 0 0 0 0 8.484 1 1 0 0 1 0 1.414ZM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm4.243 2.656a1 1 0 0 0 1.414 0 8 8 0 0 0 0-11.312 1 1 0 1 0-1.414 1.414 6 6 0 0 1 0 8.484 1 1 0 0 0 0 1.414Z", fill: "currentColor" })));
});
ActivityIcon.displayName = 'ActivityIcon';
export default ActivityIcon;
